const Theme = {
  logo_image_url: 'aircanada.png',

  button_color: '#d8292f',
  button_half_border_color: '#d8292f',

  image_icon_hidden: true,

  text_font: `'Open Sans', sans-serif`,
  title_font: `'Open Sans', sans-serif`,
}

export default Theme
